// eslint-disable-next-line no-restricted-imports
import { isFilteringByUnreadNotifications } from 'app/src/components/NotificationsMenu/notificationsMenuState';
import { notificationsPaneState } from 'app/src/components/NotificationsMenu/notificationsPaneState';

export const isLoadingNotifications = () => {
  const counts = {
    loadingUnread: notificationsPaneState.value.loadingUnread,
    loadingAll: notificationsPaneState.value.loading,
  };

  return counts.loadingUnread > 0 || counts.loadingAll > 0;
};

export const shouldLoadMoreNotifications = () => {
  return isFilteringByUnreadNotifications()
    ? notificationsPaneState.value.moreUnreadToLoad
    : notificationsPaneState.value.moreToLoad;
};
